import Cookies from 'js-cookie';
import { SessionManager } from './SessionManager';
import { SessionProperties } from '../models';
// import { EventDispatcher } from 'ste-events';
// import { SessionIdentity } from '@samelogic/steps';
// import { OnIdentityChangedEvent } from '.';
import { SLUser } from '../../models';

// const mockedSetCookie = setCookie as jest.MockedFunction<typeof setCookie>;
// const mockedGetCookie = getCookie as jest.MockedFunction<typeof getCookie>;

describe('SessionManager', () => {
  let manager: SessionManager;
  const envId = 'envId-12345';

  const user: SLUser = {
    key: 'user-key-12345',
    email: 'test@test.com',
    name: 'Test User'
  };

  // const sessionIdentity: SessionIdentity = {
  //   sessionId: 'sessionId',
  //   userId: 'userId'
  // };
  const defaultPropertySession: SessionProperties = {
    envId: envId,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    orgId: expect.any(String),
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    projId: expect.any(String)
  };
  // const defaultUser: SLUser = {
  //   // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  //   key: expect.any(String)
  // };
  // const defaultSessionIdentity: SessionIdentity = {
  //   // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  //   sessionId: expect.any(String),
  //   // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  //   userId: expect.any(String)
  // };
  const idCookieName = `_sl_id.${envId}`;
  const propsCookieName = `_sl_props.${envId}`;
  beforeEach(() => {
    Cookies.remove(idCookieName);
    Cookies.remove(propsCookieName);
  });
  describe('constructor', () => {
    beforeEach(() => {
      manager = new SessionManager(envId);
    });
    it('should always setup a brand new property session with the envId', () => {
      const cookieProperties = JSON.parse(Cookies.get(propsCookieName) || '') as SessionProperties;
      expect(cookieProperties).toEqual(defaultPropertySession);
    });

    describe('when user defined', () => {
      beforeEach(() => {
        manager = new SessionManager(envId, user);
      });
      it('should create a default identity with generated key', () => {
        const cookieUser = JSON.parse(Cookies.get(idCookieName) || '') as SLUser;
        expect(cookieUser).toMatchObject(user);

        expect(manager.getUser()).toMatchObject(user);
      });
    });

    describe('when user undefined', () => {
      beforeEach(() => {
        manager = new SessionManager(envId);
      });
      it('should create a default identity with generated key', () => {
        const cookieUser = JSON.parse(Cookies.get(idCookieName) || '') as SLUser;
        expect(cookieUser).toMatchObject({
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          key: expect.any(String)
        });

        const user = manager.getUser();
        expect(user).toMatchObject({
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          key: expect.any(String)
        });
      });
    });

    describe('when user.key undefined', () => {
      beforeEach(() => {
        manager = new SessionManager(envId, { email: 'test@example.com' });
      });
      it('should create a default identity with generated key', () => {
        const cookieUser = JSON.parse(Cookies.get(idCookieName) || '') as SLUser;
        expect(cookieUser).toMatchObject({
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          key: expect.any(String),
          email: 'test@example.com'
        });

        const user = manager.getUser();
        expect(user).toMatchObject({
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          key: expect.any(String),
          email: 'test@example.com'
        });
      });
    });
  });

  //TODO: Test the session properties

  // describe('getIdentity', () => {
  //   beforeEach(() => {
  //     Cookies.set(idCookieName, JSON.stringify(sessionIdentity));
  //     manager = new SessionManager(envId);
  //   });
  //   it('should return it', () => {
  //     expect(manager.getSessionIdentity()).toEqual(sessionIdentity);
  //   });
  // });

  // describe('setIdentity', () => {
  //   const onChanged = jest.fn<EventDispatcher<SessionManager, SessionIdentity>, [unknown]>();
  //   beforeEach(() => {
  //     manager = new SessionManager(envId);
  //     manager.onChanged.subscribe(onChanged);
  //     manager.setSessionIdentity(sessionIdentity);
  //   });
  //   it('should set the identity', () => {
  //     const cookieIdentity = JSON.parse(Cookies.get(idCookieName) || '') as SessionIdentity;
  //     expect(cookieIdentity).toEqual(sessionIdentity);
  //   });
  //   it('should fire onChanged', () => {
  //     const expected: OnIdentityChangedEvent = {
  //       property: 'identity',
  //       value: defaultSessionIdentity
  //     };
  //     expect(onChanged).toBeCalledWith(expect.anything(), expected, expect.anything());
  //   });
  // });

  // describe('resetIdentity', () => {
  //   const onChanged = jest.fn<EventDispatcher<SessionManager, SessionIdentity>, [unknown]>();
  //   beforeEach(() => {
  //     manager = new SessionManager(envId);
  //     manager.onChanged.subscribe(onChanged);
  //     manager.resetSessionIdentity();
  //   });
  //   it('should reset the identity', () => {
  //     const cookieIdentity = JSON.parse(Cookies.get(idCookieName) || '') as SessionIdentity;
  //     expect(cookieIdentity).toEqual(defaultSessionIdentity);
  //   });
  //   it('should fire onChanged', () => {
  //     const expected: OnIdentityChangedEvent = {
  //       property: 'identity',
  //       value: defaultSessionIdentity
  //     };
  //     expect(onChanged).toBeCalledWith(expect.anything(), expected, expect.anything());
  //   });
  // });
});
